import type { ShellClientData } from '@suiteux/suiteux-shell';
import checkForTeams from './checkForTeams';
import { isFeatureEnabled } from 'owa-feature-flags';
import { lazyIsTeamsChatEnabled } from 'owa-teams-policies';

export default async function isTeamsEnabled(shellClientData: ShellClientData): Promise<boolean> {
    if (isFeatureEnabled('fwk-teamsPolicies')) {
        return lazyIsTeamsChatEnabled.importAndExecute();
    } else {
        return checkForTeams(shellClientData);
    }
}
